"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Backdrop = exports.Footer = exports.Body = exports.Content = exports.Dialog = exports.Header = exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Modal.css");
var backgroundClick = function (event, onBackgroundClick) {
    if (event.currentTarget.matches('.modal')) {
        onBackgroundClick();
    }
};
var Modal = function (_a) {
    var children = _a.children, onBackgroundClick = _a.onBackgroundClick, className = _a.className, restProps = __rest(_a, ["children", "onBackgroundClick", "className"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: (0, classnames_1["default"])('modal', className), style: { display: 'block' }, onClick: function (event) {
            return onBackgroundClick ? backgroundClick(event, onBackgroundClick) : {};
        } }), children));
};
exports.Modal = Modal;
var Header = function (_a) {
    var title = _a.title, children = _a.children, className = _a.className, restProps = __rest(_a, ["title", "children", "className"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: (0, classnames_1["default"])('modal-header', className) }),
        title && react_1["default"].createElement("h1", null, title),
        children));
};
exports.Header = Header;
var Dialog = function (_a) {
    var children = _a.children, className = _a.className, restProps = __rest(_a, ["children", "className"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: (0, classnames_1["default"])('modal-dialog', className) }), children));
};
exports.Dialog = Dialog;
var Content = function (_a) {
    var children = _a.children, className = _a.className, restProps = __rest(_a, ["children", "className"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: (0, classnames_1["default"])('modal-content', className) }), children));
};
exports.Content = Content;
var Body = function (_a) {
    var children = _a.children, className = _a.className, restProps = __rest(_a, ["children", "className"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: (0, classnames_1["default"])('modal-body', className) }), children));
};
exports.Body = Body;
var Footer = function (_a) {
    var children = _a.children, className = _a.className, restProps = __rest(_a, ["children", "className"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: (0, classnames_1["default"])('modal-footer', className) }), children));
};
exports.Footer = Footer;
var Backdrop = function (_a) {
    var className = _a.className, restProps = __rest(_a, ["className"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: (0, classnames_1["default"])('modal-backdrop fade in', className) })));
};
exports.Backdrop = Backdrop;
